module.exports = __webpack_public_path__ + "img/icon-error.4ace9687.png";